(function () {

  'use strict';


  class VanillaSlider {

    constructor(element) {

      this.slider = element;

      this.track =
        element.querySelector('.js-slider-track');

      this.prev =
        element.querySelector('.js-slider-prev');

      this.next =
        element.querySelector('.js-slider-next');


      if (!this.track) {
        return;
      }


      this.originalSlides =
        Array.from(this.track.children);


      if (this.originalSlides.length < 2) {
        return;
      }


      this.currentIndex = 0;

      this.perPage = this.slider.dataset.perPage;

      this.autoplayTimer = null;

      this.isAnimating = false;

      this.touchStartX = 0;

      this.resizeTimer = null;


      this.init();

    }


  getPerPage() {
  const width = window.innerWidth;

  if (width <= 480) return 2;
  if (width <= 768) return 3;
  if (width <= 1024) return 4;

  return Number(this.slider.dataset.perPage) || 5;
}


    init() {

      this.buildSlides();

      this.bindEvents();

      this.startAutoplay();

    }


    buildSlides() {

      this.track.innerHTML = '';


      this.perPage =
        this.getPerPage();


      const cloneCount =
        Math.min(
          this.perPage,
          this.originalSlides.length
        );


      /*
       * Clone last slides
       */

      for (
        let i =
          this.originalSlides.length - cloneCount;

        i <
        this.originalSlides.length;

        i++
      ) {

        const clone =
          this.originalSlides[i].cloneNode(true);

        clone.classList.add('is-clone');

        this.track.appendChild(clone);

      }


      /*
       * Add real slides
       */

      this.originalSlides.forEach(
        (slide) => {

          const realSlide =
            slide.cloneNode(true);

          realSlide.classList.remove(
            'is-clone'
          );

          this.track.appendChild(
            realSlide
          );

        }
      );


      /*
       * Clone first slides
       */

      for (
        let i = 0;

        i < cloneCount;

        i++
      ) {

        const clone =
          this.originalSlides[i].cloneNode(true);

        clone.classList.add('is-clone');

        this.track.appendChild(clone);

      }


      /*
       * Start on first real slide
       */

      this.currentIndex =
        cloneCount;


      this.setPosition(false);

    }


    setPosition(animate = true) {
  const width = window.innerWidth;

    
      
  if(width <= 480){
     var slideWidth =
        100 / 2;
  }
  else if(width <= 768){
     var slideWidth =
        100 / 3;
  }
  else if(width <= 1024){
      var slideWidth =
        100 / 4;
  }
  else{
  var slideWidth =
        100 / this.perPage;
  } 
  
  



      this.track.style.transition =
        animate
          ? 'transform 450ms ease'
          : 'none';


      this.track.style.transform =
        `translate3d(
          -${this.currentIndex * slideWidth}%,
          0,
          0
        )`;

    }


    nextSlide() {

      if (this.isAnimating) {
        return;
      }


      this.isAnimating = true;

      this.currentIndex++;

      this.setPosition(true);

    }


    previousSlide() {

      if (this.isAnimating) {
        return;
      }


      this.isAnimating = true;

      this.currentIndex--;

      this.setPosition(true);

    }


    handleTransitionEnd() {

      const cloneCount =
        this.perPage;

      const realCount =
        this.originalSlides.length;


      /*
       * Passed last real slide
       */

      if (
        this.currentIndex >=
        realCount + cloneCount
      ) {

        this.currentIndex =
          cloneCount;

        this.setPosition(false);

      }


      /*
       * Passed first real slide
       */

      else if (
        this.currentIndex <
        cloneCount
      ) {

        this.currentIndex =
          realCount +
          this.currentIndex;

        this.setPosition(false);

      }


      this.isAnimating = false;

    }


    startAutoplay() {

      this.stopAutoplay();


      if (
        this.originalSlides.length <=
        this.perPage
      ) {
        return;
      }


      this.autoplayTimer =
        setInterval(
          () => {

            this.nextSlide();

          },
          3000
        );

    }


    stopAutoplay() {

      if (this.autoplayTimer) {

        clearInterval(
          this.autoplayTimer
        );

        this.autoplayTimer =
          null;

      }

    }


    bindEvents() {

      /*
       * Next
       */

      if (this.next) {

        this.next.addEventListener(
          'click',
          () => {

            this.nextSlide();

            this.startAutoplay();

          }
        );

      }


      /*
       * Previous
       */

      if (this.prev) {

        this.prev.addEventListener(
          'click',
          () => {

            this.previousSlide();

            this.startAutoplay();

          }
        );

      }


      /*
       * Transition
       */

      this.track.addEventListener(
        'transitionend',
        () => {

          this.handleTransitionEnd();

        }
      );


      /*
       * Pause on hover
       */

      this.slider.addEventListener(
        'mouseenter',
        () => {

          this.stopAutoplay();

        }
      );


      this.slider.addEventListener(
        'mouseleave',
        () => {

          this.startAutoplay();

        }
      );


      /*
       * Touch start
       */

      this.track.addEventListener(
        'touchstart',
        (event) => {

          this.touchStartX =
            event.changedTouches[0].screenX;

          this.stopAutoplay();

        },
        { passive: true }
      );


      /*
       * Touch end
       */

      this.track.addEventListener(
        'touchend',
        (event) => {

          const touchEndX =
            event.changedTouches[0].screenX;


          const difference =
            this.touchStartX -
            touchEndX;


          if (
            Math.abs(difference) > 50
          ) {

            if (difference > 0) {

              this.nextSlide();

            } else {

              this.previousSlide();

            }

          }


          this.startAutoplay();

        },
        { passive: true }
      );


      /*
       * Resize
       */

      window.addEventListener(
        'resize',
        () => {

          clearTimeout(
            this.resizeTimer
          );


          this.resizeTimer =
            setTimeout(
              () => {

                const newPerPage =
                  this.getPerPage();


                if (
                  newPerPage !==
                  this.perPage
                ) {

                  this.stopAutoplay();

                  this.buildSlides();

                  this.startAutoplay();

                }

              },
              200
            );

        }
      );

    }

  }


  /*
   * Initialize ALL sliders
   */

  function initializeSliders(container = document) {

   const sliders = container.querySelectorAll(
  '.js-collection-slider, .js-new-arrivals-slider'
);


    sliders.forEach(
      (slider) => {

        if (
          slider.dataset.sliderReady ===
          'true'
        ) {
          return;
        }


        slider.dataset.sliderReady =
          'true';


        new VanillaSlider(slider);

      }
    );

  }


  /*
   * Initial page load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initializeSliders();

      }
    );

  } else {

    initializeSliders();

  }


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeSliders(
        event.target
      );

    }
  );


  /*
   * Shopify Theme Editor section unload
   */

  document.addEventListener(
    'shopify:section:unload',
    (event) => {

      const slider =
        event.target.querySelector(
          '.js-collection-slider'
        );


      if (slider) {

        slider.dataset.sliderReady =
          'false';

      }

    }
  );


})();